import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp8};
  align-items: center;
  border-radius: ${props => props.theme.primitives.radius.radius2};

  ${props =>
    typeof props.onClick === 'function' &&
    css`
      cursor: pointer;
      &:hover {
        background-color: ${props.theme.colors.background.secondary};
      }
    `}
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  width: 100%;
`

export const ReasonTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const ProgressBarAndCountContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`

export const NavigationContainer = styled.div`
  min-width: ${props => props.theme.size.S};

  svg {
    display: none;
  }

  ${Container}:hover & {
    svg {
      display: block;
    }
  }
`
